<template>
  <div class="contact-form-container">
    <h1>Contact Us</h1>
    <p>We'd love to hear from you! Please fill out the form below to get in touch.</p>
    <form @submit.prevent="submitForm" class="contact-form">
      <div class="form-group">
        <label for="name">Full Name</label>
        <input type="text" id="name" v-model="form.name" placeholder="Enter your name" required />
      </div>
      <div class="form-group">
        <label for="email">Email Address</label>
        <input type="email" id="email" v-model="form.email" placeholder="Enter your email" required />
      </div>
      <div class="form-group">
        <label for="message">Your Message</label>
        <textarea id="message" v-model="form.message" placeholder="Write your message" required></textarea>
      </div>
      <button type="submit" class="submit-btn">Submit</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      form: {
        name: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    submitForm() {
      alert("Form submitted!");
      this.form.name = "";
      this.form.email = "";
      this.form.message = "";
    },
  },
};
</script>


<style scoped>
/* Import the custom font */
@font-face {
  font-family: "WixMadeforText";
  src: url("@/assets/WixMadeforText-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.contact-form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: "WixMadeforText", sans-serif;
}

h1 {
  text-align: center;
  color: #333;
  font-size: 28px;
  margin-bottom: 20px;
}

p {
  text-align: center;
  color: #555;
  font-size: 16px;
  margin-bottom: 30px;
}

.contact-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 20px;
}

label {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

input,
textarea {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

textarea {
  height: 150px;
  resize: vertical;
}

button.submit-btn {
  background-color: #00bcd4;
  color: white;
  font-size: 18px;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button.submit-btn:hover {
  background-color: #0097a7;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .contact-container {
    padding: 15px;
  }

  h1 {
    font-size: 24px;
  }

  p {
    font-size: 14px;
  }

  button.submit-btn {
    font-size: 16px;
    padding: 10px 15px;
  }
}
</style>

